// extracted by mini-css-extract-plugin
module.exports = {"spinner-container":"RelativeEffort--spinner-container--tTqjk","spinnerContainer":"RelativeEffort--spinner-container--tTqjk","container":"RelativeEffort--container--3Yylq"};